var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerswhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02312 8.98833C7.93307 8.97933 7.82501 8.97933 7.72596 8.98833C5.58279 8.91629 3.88086 7.16034 3.88086 4.99916C3.88086 2.79295 5.66383 1.00098 7.87904 1.00098C10.0852 1.00098 11.8772 2.79295 11.8772 4.99916C11.8682 7.16034 10.1663 8.91629 8.02312 8.98833Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5516 2.80176C16.2986 2.80176 17.7034 4.21553 17.7034 5.95348C17.7034 7.6554 16.3526 9.04216 14.6687 9.1052C14.5967 9.09619 14.5156 9.09619 14.4346 9.1052",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52062 12.3111C1.34143 13.7699 1.34143 16.1472 3.52062 17.597C5.99697 19.2539 10.0582 19.2539 12.5345 17.597C14.7137 16.1382 14.7137 13.7609 12.5345 12.3111C10.0672 10.6632 6.00598 10.6632 3.52062 12.3111Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2896 17.2096C16.9379 17.0745 17.5502 16.8134 18.0545 16.4262C19.4593 15.3726 19.4593 13.6346 18.0545 12.5811C17.5592 12.2029 16.9559 11.9507 16.3166 11.8066",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerswhite);
export default __webpack_public_path__ + "static/media/playerswhite.17a411f5ffbb9f21a3740ed508252819.svg";
export { ForwardRef as ReactComponent };